export const checkQtyStatus = (
  qty: number,
  qty_build_unit: number,
  soh: number,
  avg_price:number
): boolean => {
  if(soh === 0) return false
  if(avg_price === 0) return false
  return (qty * qty_build_unit) <= soh
}